export enum BooleanOptions {
  TRUE = 'TRUE',
  FALSE = 'FALSE',
}

export function getBooleanFromString(str: string): boolean | null {
  switch (str.toLowerCase()) {
    case BooleanOptions.TRUE.toLowerCase():
      return true;
    case BooleanOptions.FALSE.toLowerCase():
      return false;
    default:
      return null;
  }
}

export function getStringFromBoolean(bool?: boolean | null): string {
  switch (bool) {
    case true:
      return BooleanOptions.TRUE;
    case false:
      return BooleanOptions.FALSE;
    default:
      return '';
  }
}
